<template>
  <div class="m-msg-market-item">
    <!-- specifiers -->
    <template v-if="marketTitles.length > outcomeSize">
      <div
        v-if="currentSpecifier"
        class="m-outcome m-specifier"
      >
        <VSelect
          v-model="currentSpecifier"
          icon="icon-sanjiao"
          :list="specifiers.specifiersList"
          :description="outcomeDescriptions[0]"
          @change="onSelectSpecifier"
          @visible="onSelectVisible"
        />
      </div>

      <Outcome
        v-else
        :disabled="true"
        :description="outcomeDescriptions[0]"
      />
    </template>

    <!-- outcomes -->
    <template v-if="hasOutcomes">
      <template v-for="(outcomeId, index) in currentMarket.outcomes.order">
        <Outcome
          :key="`${marketId}-${currentSpecifier}-${outcomeId}`"
          :outcome="currentMarket.outcomes.map[outcomeId]"
          :market="currentMarket"
          :event="event"
          :show-desc="showOutcomeDesc"
          :description="outcomeDescriptions[isSpecifiers ? index + 1 : index]"
        />
      </template>
    </template>

    <template v-else>
      <template v-for="item in outcomeNullCount">
        <Outcome
          :key="item"
          :disabled="true"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Outcome from './Outcome'
import sortMarkets from './sortMarkets'
import VSelect from './VSelect'

/**
 * specifier 自动切换规则
 * 当有推送消息时，保持赛事列表页中的Specifier列表的新增（非deactivated和settled）和去除（deactivated和settled），并且specifier列表需要排序。同时如果当前Specifier出现了deactivated或settled，就寻找新的值最小且isFavourite=1的specifier（如果没有isFavorite=1的specifier，就取值最小的specifier）填充到页面上。如果所有的specifier都已经是deactivated或settled，才将specifier一列置为上锁（注意在specifier列上锁时，如果又有非deactivated和settled的specifier随着推送出现，应该去除specifier列的上锁，并按照上述规则寻找应该显示的specifier）
 */

export default {
  name: 'MsgMarketItem',
  components: {
    Outcome,
    VSelect
  },
  props: {
    market: {
      type: [Object, Array],
      default: () => null
    },
    marketId: {
      type: [Number, String],
      default: ''
    },
    outcomeSize: {
      type: Number,
      default: 3
    },
    marketTitles: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => null
    },
    showOutcomeDesc: {
      type: Boolean,
      default: false
    },
    outcomeDescriptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentSpecifier: '',
      currentSpecifierIndex: -1
    }
  },
  computed: {
    // 为空的 outcome 有多少个
    outcomeNullCount() {
      const marketLength = this.marketTitles.length
      const outcomeSize = this.outcomeSize
      if (this.isSpecifiers) {
        // 部分 specifiers 可能存在 4 个 outcome，所以这里要做判断
        return marketLength > outcomeSize ? outcomeSize : marketLength
      }
      return this.outcomeSize
    },
    hasOutcomes() {
      const { currentMarket } = this
      return currentMarket && currentMarket.outcomes && currentMarket.outcomes.order && currentMarket.outcomes.order.length > 0
    },
    isSpecifiers() {
      return Array.isArray(this.market)
    },
    specifiers() {
      if (!this.isSpecifiers) return {}
      const list = this.market.filter((market) => market.status === 0 || market.status === 1)
      return sortMarkets(list)
    },
    currentMarket() {
      const { market } = this
      if (this.isSpecifiers) {
        const { currentSpecifierIndex } = this
        if (currentSpecifierIndex >= 0) {
          return this.specifiers.markets[currentSpecifierIndex]
        }
        const favouriteMarkets = market.filter((x) => x.isFavourite)
        return favouriteMarkets[0] || market[0]
      } else {
        return market
      }
    },
    isShowSelect() {
      return this.marketTitles.length > this.outcomeSize
    }
  },
  watch: {
    marketId(val) {
      if (val) {
        this.init()
      }
    },
    'specifiers.specifiersList'(list) {
      if (Array.isArray(list) && list.includes(this.currentSpecifier)) {
        const index = list.findIndex((x) => x === this.currentSpecifier)
        this.onSelectSpecifier(index)
      } else {
        this.init()
      }
    },
    'currentMarket.status'(status) {
      if (status === 2 || status === 3) {
        // Deactivated / Settled
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.isSpecifiers) {
        let i = this.specifiers.markets.findIndex((x) => !!x.isFavourite)
        i = i !== -1 ? i : 0
        this.currentSpecifierIndex = i
        this.currentSpecifier = this.specifiers.specifiersList[i]
      } else {
        this.currentSpecifierIndex = -1
        this.currentSpecifier = ''
      }
    },
    onSelectSpecifier(index) {
      this.currentSpecifierIndex = index
      this.currentSpecifier = this.specifiers.specifiersList[index]
    },
    onSelectVisible(visible) {
      this.$emit('selectVisible', visible)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-msg-market-item {
  display: flex;
  align-items: center;

  .m-specifier {
    position: relative;
  }
}
</style>
